"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MooncrateBlockFactory = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var CardRequirements_1 = require("../CardRequirements");
var MooncrateBlockFactory = (function (_super) {
    __extends(MooncrateBlockFactory, _super);
    function MooncrateBlockFactory() {
        return _super.call(this, {
            name: CardName_1.CardName.MOONCRATE_BLOCK_FACTORY,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.BUILDING],
            cost: 8,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.miningTiles(1); }),
            metadata: {
                description: 'Requires 1 mine on the Moon.',
                cardNumber: 'M38',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you pay for a Lunar standard project, you spend 4M€ less.', function (eb) {
                        eb.plate('Lunar standard projects').startEffect.megacredits(-4);
                    });
                }),
            },
        }) || this;
    }
    ;
    MooncrateBlockFactory.prototype.play = function () {
        return undefined;
    };
    return MooncrateBlockFactory;
}(Card_1.Card));
exports.MooncrateBlockFactory = MooncrateBlockFactory;
